import React, { Component } from 'react';
import PropTypes from 'prop-types';

import _isEqual from 'lodash/isEqual';

import { dictionariesEntry } from 'types';

class RowColumnInput extends Component {
  static propTypes = {
    entry: dictionariesEntry,
    col: PropTypes.shape({
      id: PropTypes.string,
      archived: PropTypes.bool,
    }),
    entryIndex: PropTypes.number,
    saveOnEnterPress: PropTypes.bool.isRequired,
    index: PropTypes.number,
    focus: PropTypes.shape({
      row: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      col: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    onFocus: PropTypes.func.isRequired,
    onUpdateRow: PropTypes.func.isRequired,
    onSaveRowUpdate: PropTypes.func.isRequired,
  };

  shouldComponentUpdate(nextProps) {
    return (
      !_isEqual(nextProps.entry, this.props.entry) ||
      !_isEqual(nextProps.col, this.props.col) ||
      !_isEqual(nextProps.focus, this.props.focus)
    );
  }

  componentDidUpdate() {
    const { focus, entryIndex, index } = this.props;

    if (focus.row === entryIndex && focus.col === index) {
      this.inputComponent.focus();
    }
  }

  handleClick = () => {
    const { index, entryIndex, onFocus } = this.props;
    onFocus({
      row: entryIndex,
      col: index,
    });
  };

  handleSave = async ({ target: { value } }) => {
    await this.props.onUpdateRow(this.props.entry, this.props.col.id, value);

    this.props.onSaveRowUpdate(this.props.entry);
  };

  handleRef = el => {
    this.inputComponent = el;
  };

  handleKeyDown = e => {
    if (this.props.saveOnEnterPress && e.key === 'Enter') {
      this.inputComponent.blur();
    }
  };

  render() {
    // FIXME: Pass `value` to this component instead of `entry`
    const { col, entry } = this.props;
    const value = entry.values[col.id];

    /* eslint-disable  jsx-a11y/no-noninteractive-element-interactions */
    /* eslint-disable jsx-a11y/click-events-have-key-events */

    return (
      <td>
        <input
          ref={this.handleRef}
          defaultValue={value}
          disabled={col.archived}
          onClick={this.handleClick}
          onBlur={this.handleSave}
          onKeyDown={this.handleKeyDown}
          data-test="row-column-input"
        />
      </td>
    );
  }
}

export default RowColumnInput;
